import { ModuleContent } from '../contract';

export type ObjectListSource = 'manual' | 'sameJourney' | 'genericCategories';
export type ObjectListObjectType = 'article' | 'education' | 'quiz';
export type ObjectListManualObjectType = 'cmsPage' | 'blog';

export type ObjectListManualItem = {
	objectType: ObjectListManualObjectType;
	objectId: number;
};

export type ObjectListModuleContent = {
	source: ObjectListSource;
	objectTypes: ObjectListObjectType[];
	limit?: number;
	genericCategoryIds?: number[];
	manualItems?: ObjectListManualItem[];
	top?: number;
	itemTemplate: string;
	customCss?: string;
	mobileCustomCss?: string;
	emptyStateText?: string;
};

const VALID_OBJECT_LIST_TYPES: ObjectListObjectType[] = ['article', 'education', 'quiz'];
const VALID_OBJECT_LIST_SOURCES: ObjectListSource[] = ['manual', 'sameJourney', 'genericCategories'];
const VALID_MANUAL_OBJECT_TYPES: ObjectListManualObjectType[] = ['cmsPage', 'blog'];

export function isObjectListModuleContent(content: ModuleContent): content is ObjectListModuleContent {
	const objectListContent = content as ObjectListModuleContent;

	return (
		VALID_OBJECT_LIST_SOURCES.includes(objectListContent?.source) &&
		Array.isArray(objectListContent.objectTypes) &&
		objectListContent.objectTypes.every((value) => VALID_OBJECT_LIST_TYPES.includes(value)) &&
		(objectListContent.source !== 'sameJourney' || typeof objectListContent.limit === 'number') &&
		(objectListContent.source !== 'genericCategories' || typeof objectListContent.top === 'number') &&
		(objectListContent.manualItems === undefined ||
			(Array.isArray(objectListContent.manualItems) &&
				objectListContent.manualItems.every(
					(item) =>
						VALID_MANUAL_OBJECT_TYPES.includes(item?.objectType) &&
						Number.isInteger(item?.objectId) &&
						item.objectId > 0
				))) &&
		typeof objectListContent.itemTemplate === 'string' &&
		(objectListContent.customCss === undefined || typeof objectListContent.customCss === 'string') &&
		(objectListContent.mobileCustomCss === undefined || typeof objectListContent.mobileCustomCss === 'string') &&
		(objectListContent.genericCategoryIds === undefined ||
			(Array.isArray(objectListContent.genericCategoryIds) &&
				objectListContent.genericCategoryIds.every((value) => Number.isInteger(value)))) &&
		(objectListContent.top === undefined || typeof objectListContent.top === 'number')
	);
}

export function getObjectListModuleIndexableText(content: ModuleContent): string {
	if (!isObjectListModuleContent(content)) return '';

	return [content.itemTemplate, content.emptyStateText ?? '']
		.join(' ')
		.replace(/<[^>]*>/g, ' ')
		.trim();
}
